/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../../../app/dialog/dialog.actions';
import { deleteActivity } from '../../../../../../../../app/page/page-storage/activities/activities.actions';
import { activitySelectors } from '../../../../../../../../app/resource/activity/activity.selectors';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IActivityProps } from './types';
import { CircularAvatar } from '../../../../../CustomAvatar';
import { convertAndFormatDateToUserTimeZone } from '../../../../../../../../utils/date.utils';
import { IActivity } from '../../../../../../../../app/resource/activity/activity.types';

export const Activity: FunctionComponent<IActivityProps> = ({ activityId }) => {
  const activity = useSelectWithParams(activitySelectors.selectResourceById, activityId) as IActivity | null;
  const user = useSelectWithParams(userSelectors.selectResourceById, activity ? activity.changedBy : '');
  const dispatch = useDispatch();
  const activityData = activity;

  const createMarkup = useMemo(() => ({ __html: activity ? activity.description : '' }), [activity]);
  const activityTime = useMemo(
    () =>
      activity && user
        ? `${convertAndFormatDateToUserTimeZone(
            activity.changedAt,
            user.timezone ?? null,
            'MM/DD',
          )} at ${convertAndFormatDateToUserTimeZone(activity.changedAt, user.timezone ?? null, 'HH:mm A')}`
        : '',
    [activity, user],
  );

  const toggleEdit = useCallback(() => {
    if (activityData) {
      dispatch(openDialog('activityFormDialog', { activityData, taskId: activityData.taskId }));
    }
  }, [activityData, dispatch]);

  const toggleDelete = useCallback(() => {
    dispatch(deleteActivity(activityId));
  }, [activityId, dispatch]);

  const fileUrl = activity?.description.split('"')[1];
  const fileUrlParts = fileUrl?.split('.');
  let fileType = fileUrlParts ? fileUrlParts[fileUrlParts.length - 1] : null;
  if (fileType?.includes('?')) {
    const fileTypeParts = fileType?.split('?');
    fileType = fileTypeParts ? fileTypeParts[0] : null;
  }

  const isImg =
    fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif' || fileType === 'tiff'
      ? true
      : false;

  return (
    <div className="single-activity" style={{ justifyContent: 'space-between' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <a className="small-avatar mr-1">
          {user && <CircularAvatar src={user.image} title={`${user.firstName} ${user.lastName}`} classes="iflumg-id" />}
        </a>
        <div className="single-activity-desc">
          <b>{`${user?.firstName}${user?.lastName}`}</b> <div dangerouslySetInnerHTML={createMarkup}></div>
          {isImg && (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <img src={fileUrl} alt="img" style={{ width: '100px' }} />
            </a>
          )}
          <div className="activity-date blueGray">{activityTime}</div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="round-icon-small mr-1" onClick={toggleEdit}>
          {' '}
          <i className="icon-pencil"></i>
        </div>
        <div onClick={toggleDelete}>
          <a className="round-icon-small mr-0 popup_button" data-popup="delete_popup">
            <i className="icon2-trash" />
          </a>
        </div>
      </div>
    </div>
  );
};
